import { Navigate, Outlet } from 'react-router-dom';
import FullLayout from '../layouts/FullLayout';
import { useAuth } from '../components/context/AuthContext';

// Función para verificar si el usuario está autenticado
const PrivateRoute = () => {
    const { accessToken } = useAuth();
  
    return accessToken ? <FullLayout><Outlet /></FullLayout> : <Navigate to="/auth/login" replace />;
  };
  
  export default PrivateRoute;
